var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ExternalWalletProvider } from '../../providers/ExternalWalletContext.js';
import { EvmExternalWalletContext, EvmExternalWalletProvider, } from '../../providers/EvmExternalWalletContextStub.js';
import { 
// CosmosWallet,
EvmWallet, SolanaWallet, } from '../../types/externalWallets.js';
import { SolanaExternalWalletContext, SolanaExternalWalletProvider, } from '../../providers/SolanaExternalWalletContextStub.js';
import { CosmosExternalWalletContext, CosmosExternalWalletProvider, } from '../../providers/CosmosExternalWalletContextStub.js';
import { useCapsuleStore, useModalStore, useUserInfoStore } from '../../stores/index.js';
import { useExternalWalletProviderStore } from '../../stores/externalWalletProvider/useExternalWalletProviderStore.js';
export const ExternalWalletsWrapper = ({ children, wallets }) => {
    const capsule = useCapsuleStore(state => state.capsule);
    const resetModalState = useModalStore(state => state.resetState);
    const resetUserInfoState = useUserInfoStore(state => state.resetState);
    const StoredEvmProvider = useExternalWalletProviderStore(state => state.EvmProvider);
    const storedEvmContext = useExternalWalletProviderStore(state => state.evmContext);
    const StoredSolanaProvider = useExternalWalletProviderStore(state => state.SolanaProvider);
    const storedSolanaContext = useExternalWalletProviderStore(state => state.solanaContext);
    // const StoredCosmosProvider = useExternalWalletProviderStore(state => state.CosmosProvider);
    // const storedCosmosContext = useExternalWalletProviderStore(state => state.cosmosContext);
    // EVM
    const [EvmProvider, setEvmProvider] = useState(null);
    const [evmContext, setEvmContext] = useState(null);
    // Solana
    const [SolanaProvider, setSolanaProvider] = useState(null);
    const [solanaContext, setSolanaContext] = useState(null);
    // Cosmos
    const [CosmosProvider, setCosmosProvider] = useState(null);
    const [cosmosContext, setCosmosContext] = useState(null);
    useEffect(() => {
        const loadProviders = () => __awaiter(void 0, void 0, void 0, function* () {
            let newEvmContext = EvmExternalWalletContext;
            let newEvmProvider = EvmExternalWalletProvider;
            let newSolanaContext = SolanaExternalWalletContext;
            let newSolanaProvider = SolanaExternalWalletProvider;
            let newCosmosContext = CosmosExternalWalletContext;
            let newCosmosProvider = CosmosExternalWalletProvider;
            if (!(wallets === null || wallets === void 0 ? void 0 : wallets.length)) {
                newEvmContext = EvmExternalWalletContext;
                newEvmProvider = EvmExternalWalletProvider;
                newSolanaContext = SolanaExternalWalletContext;
                newSolanaProvider = SolanaExternalWalletProvider;
                newCosmosContext = CosmosExternalWalletContext;
                newCosmosProvider = CosmosExternalWalletProvider;
            }
            else {
                for (let i = 0; i < wallets.length; i++) {
                    const wallet = wallets[i];
                    // Handle EVM Wallets
                    if (wallet in EvmWallet) {
                        if (!StoredEvmProvider || !storedEvmContext) {
                            throw new Error('@usecapsule/evm-wallet-connectors is required to use an external EVM wallet.');
                        }
                        else {
                            newEvmContext = storedEvmContext;
                            newEvmProvider = StoredEvmProvider;
                        }
                    }
                    // Handle Solana Wallets
                    if (wallet in SolanaWallet) {
                        if (!StoredSolanaProvider || !storedSolanaContext) {
                            throw new Error('@usecapsule/solana-wallet-connectors is required to use an external Solana wallet.');
                        }
                        else {
                            newSolanaContext = storedSolanaContext;
                            newSolanaProvider = StoredSolanaProvider;
                        }
                    }
                    // Handle Cosmos Wallets
                    // if (wallet in CosmosWallet) {
                    //   if (!StoredCosmosProvider || !storedCosmosContext) {
                    //     throw new Error('@usecapsule/cosmos-wallet-connectors is required to use an external Cosmos wallet.');
                    //   } else {
                    //     newCosmosContext = storedCosmosContext;
                    //     newCosmosProvider = StoredCosmosProvider;
                    //   }
                    // }
                    newCosmosContext = CosmosExternalWalletContext;
                    newCosmosProvider = CosmosExternalWalletProvider;
                }
            }
            setEvmContext(newEvmContext);
            setEvmProvider(() => newEvmProvider);
            setSolanaContext(newSolanaContext);
            setSolanaProvider(() => newSolanaProvider);
            setCosmosContext(newCosmosContext);
            setCosmosProvider(() => newCosmosProvider);
        });
        loadProviders();
    }, [wallets, storedEvmContext, StoredEvmProvider, storedSolanaContext, StoredSolanaProvider]);
    const handleSwitchWallet = ({ address, error }) => {
        // If we error on switch wallets we logged out the Capsule instance so we need to reset the modal state
        // Or if we don't return an address on switch wallets we logged out the Capsule instance so we need to reset the modal state
        if (error || !address) {
            resetModalState();
            resetUserInfoState();
        }
    };
    if (!capsule || !EvmProvider || !SolanaProvider || !CosmosProvider) {
        return null;
    }
    return (_jsx(EvmProvider, { capsule: capsule, onSwitchWallet: handleSwitchWallet, children: _jsx(SolanaProvider, { capsule: capsule, onSwitchWallet: handleSwitchWallet, children: _jsx(CosmosProvider, { capsule: capsule, onSwitchWallet: handleSwitchWallet, children: _jsx(ExternalWalletProvider, { evmContext: evmContext, solanaContext: solanaContext, cosmosContext: cosmosContext, walletSort: wallets, children: children }) }) }) }));
};
